import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { CommentInput } from 'src/app/models/server/comment-input';

@Component({
    selector: 'app-delete-comment',
    templateUrl: './delete-comment.component.html',
    styleUrls: ['./delete-comment.component.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose]
})
export class DeleteCommentComponent {
    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<DeleteCommentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CommentInput
    ) {}
}
